<template>
<div>Sms</div>
</template>

<script>
export default {
  name: "Index"
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/Sms/Index.vue